<div class="newtable-wrapper" #tableWrapper>
    <p-table
        *ngIf="showTable"
        #dt
        class="pr-table"
        [columns]="(selectedOption) ? getSelectedColumns() : selectedColumnsControl.value"
        [value]="tableData"
        [loading]="isLoading"
        [resizableColumns]="true"
        [paginator]="true"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
        [reorderableColumns]="true"
        [scrollable]="true"
        stateStorage="local"
        [stateKey]="tableId"
        (onColReorder)="this.onColReorder($event)"
        (onColResize)="this.onColResize($event)"
        [(selection)]="selected"
        dataKey="{{this.idFieldName}}"
        selectionMode="multiple"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="od {first} do {last} z {totalRecords}"
    >
        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <col
                    *ngFor="let col of columns"
                    [style.width]="col?.width + '%'"
                >
            </colgroup>
        </ng-template>

        <ng-template pTemplate="caption">
            <div class="table-header" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex fxLayoutGap="10px">
                    <button mat-button (click)="resetTable()">
                        <mat-icon
                            class="text-primary"
                        >
                            settings_backup_restore
                        </mat-icon>
                    </button>
                    <p-multiSelect [options]="columnsData" [formControl]="selectedColumnsControl" optionLabel="header"
                                   selectedItemsLabel="{0} columns selected" [style]="{maxWidth: '200px'}"
                                   defaultLabel="Choose Columns"></p-multiSelect>
                </div>

                <div fxLayout="row"
                     fxLayoutAlign="center center"
                     fxFlex
                     fxLayoutGap="10px"
                >
                    <div
                        class="search-wrapper"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxFlex
                    >
                        <input
                            matInput
                            #filter
                            placeholder="Wpisz szukaną frazę"
                            class="search-bar"
                            [formControl]="filterGlobalControl"
                            (keyup.enter)="dt.filterGlobal(filterGlobalControl.value, 'contains')"
                        />
                        <mat-icon class="text-primary" (click)="clearGlobalFilter()">close</mat-icon>
                        <mat-icon
                            class="text-primary"
                            (click)="dt.filterGlobal(filterGlobalControl.value, 'contains')"
                        >
                            search
                        </mat-icon>
                    </div>

                    <div
                        *ngIf="extraHeaderFieldTmpl"
                        class="extra-header-field"
                    >
                        <ng-container *ngTemplateOutlet="extraHeaderFieldTmpl;"></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th
                    *ngFor="let col of columns"
                    pResizableColumn
                    pReorderableColumn
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.showSort === false"
                >
                    <ng-container *ngIf="col.field === 'selectedTable'">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </ng-container>


                    <ng-container *ngIf="col.field !== 'selectedTable'">
                        {{ col.header }}
                        <p-sortIcon *ngIf="col.showSort !== false" [field]="col.field"></p-sortIcon>

                        <pr-select-by-column
                            [column]="col"
                            [dt]="dt"
                        ></pr-select-by-column>
                    </ng-container>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr (click)="goToUrl(row)">
                <td
                    [ngClass]="'pr-table-coltype-' + column.dataType"
                    class="ui-resizable-column"
                    *ngFor="let column of columns"
                >
                    <div fxLayout="row">
                        <ng-container *ngIf="column.field === 'selectedTable'">
                            <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                                <p-tableCheckbox [value]="row"></p-tableCheckbox>
                            </div>
                        </ng-container>


                        <ng-container *ngIf="column.field !== 'selectedTable' && column.field !== 'contractType'">
                            <div *ngIf="column.field === customCellName" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                                <ng-container *ngTemplateOutlet="customCellTmpl; context: { $implicit: row }"></ng-container>
                            </div>

                            <div *ngIf="column.field !== customCellName && column.type && column.type === 'date'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                                {{
                                generalService.parseDate(row[column.field]) ||
                                '-'
                                }}
                            </div>
                            <div *ngIf="column.field !== customCellName && column.type && column.type === 'datetime'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                                {{
                                generalService.parseDateWithTime(
                                    row[column.field]
                                ) || '-'
                                }}
                            </div>
                            <div
                                *ngIf="column.field !== customCellName && column.type && column.type === 'vat'"
                                [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                                class="percentage-suf"
                            >
                                {{
                                generalService.parseVAT(row[column.field])
                                    | number: '.0-0'
                                }}
                            </div>
                            <div *ngIf="column.field !== customCellName && column.type && column.type === 'number'" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                                {{ row[column.field] || '-' }}
                            </div>
                            <div *ngIf="column.field !== customCellName && !column.suffix && !column.type" [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled">
                                {{ row[column.field] || '-' }}
                            </div>
                            <div
                                *ngIf="column.field !== customCellName && column.type && column.type === 'margin'"
                                [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                                class="percentage-suf"
                            >
                                {{
                                generalService.parseVAT(row[column.field])
                                    | number: '.1-1'
                                }}
                            </div>
                            <div
                                *ngIf="
                            column.field !== customCellName &&
                                !column.type &&
                                column.suffix &&
                                column.suffix === 'percentage'
                            "
                                [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                                class="percentage-suf"
                            >
                                {{ row[column.field] || '-' }}
                            </div>
                            <div
                                *ngIf="column.field !== customCellName && column.suffix && column.suffix === 'currency'"
                                [matTooltip]="getTooltip(column, row[column.columnDef])" [matTooltipDisabled]="!column.tooltipEnabled"
                                class="currency-suf"
                            >
                                {{ (row[column.field] | number: '.2-2') || '-' }}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="column.field === 'contractType'">
                            <span *ngIf='row[column.field] === "Fix"'>Stała cena produktu</span>
                            <span *ngIf='row[column.field] === "Min"'>Minimalna cena produktu</span>
                            <span *ngIf='row[column.field] === "Max"'>Maksymalna cena produktu</span>
                        </ng-container>
                        <ng-container *ngIf="column.field === 'price'">
                                zł
                        </ng-container>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
